/* Merged cart rows (snippets/cart-line-items.liquid, cart drawer): identical lines that Shopify split because of a
   discount are shown as one row with data-merge-keys / data-merge-qtys. The theme changes a row's quantity with
   /cart/change { line, quantity } for the row's first line; for a merged row that becomes one /cart/update over all
   its lines, so the row ends up at the quantity the customer chose. Shopify may split the lines again afterwards.
   Jewelry case rows are left to assets/free-case.js. */
(() => {
  const previousFetch = window.fetch;
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  window.fetch = function (input, init) {
    try {
      const url = typeof input === 'string' ? input : (input && input.url) || '';
      if (/\/cart\/change(\.js)?(\?|$)/.test(url) && init && typeof init.body === 'string') {
        const body = JSON.parse(init.body);
        const row = body.line && document.querySelector(`[data-item-index="${Number(body.line)}"][data-merge-keys]:not([data-case-ours-qty])`);
        if (row) {
          const keys = row.dataset.mergeKeys.split(',');
          const quantities = row.dataset.mergeQtys.split(',').map(Number);
          let remaining = Math.max(0, Number(body.quantity) || 0);
          const updates = {};
          // Earlier lines keep what they have while it fits; the last line takes the rest (more or less).
          keys.forEach((key, index) => {
            const quantity = index === keys.length - 1 ? remaining : Math.min(quantities[index], remaining);
            updates[key] = quantity;
            remaining -= quantity;
          });
          return previousFetch.call(window, `${root}cart/update.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ updates }),
          });
        }
      }
    } catch (error) {
      // not a merged row: send the request as it is
    }
    return previousFetch.apply(window, arguments);
  };
})();
